<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester keyword="教師編號、教師姓名">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.Type" id="Type" label="項目">
                            <div is="option" value="">全部</div>
                            <div is="option" v-for="o in ['C3-4', 'C3-5']" :key="o" :value="o">{{o}}</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :del="del" :deleteItems="deleteItem.length">
                    <b-button variant="primary" @click="create()"><b-icon-file></b-icon-file>產生</b-button>
                </btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;">
                                <input type="checkbox" v-model="selectall" />
                            </th>
                            <th>學年度-學期</th>
                            <th>教師編號-教師姓名</th>
                            <th>項目</th>
                            <th>點數</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.PaID">
                        <td data-th="選擇"><input type="checkbox" class="del" c v-model="deleteItem" :value="item.PaID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="教師編號-教師姓名">{{item.TNo}}-{{item.Name}}</td>
                        <td data-th="項目">{{item.Type}}</td>
                        <td data-th="點數">{{item.Point}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
    </page-main>
</template>

<script>
    import { master } from '@/views';
    export default master({
        name: 'g2pa',
        api: '/api/pa/',
        query: { group: "G2" },
        methods: {
            create: function () {
                if (this.query.syear == "" || this.query.semester == "") {
                    this.$bvToast.toast("請選擇學年度、學期", { title: '發生錯誤', variant: 'danger', solid: true });
                    return;
                }

                this.$http({ method: 'post', url: '/api/pa/G2', params: this.query })
                    .then(() => { this.load() });
            }
        }
    });
</script>

<style>
</style>